var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrinnn04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 109 71",
    style: {
      enableBackground: "new 0 0 109 71"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.st0{fill:#FFFFFF;}\r\n\t\t.st1{fill:none;stroke:#010202;strokeWidth:1.0337;stroke-miterlimit:1.5801;}\r\n\t\t.st2{fill:#BEE8FF;}\r\n\t\t.st3{fill:none;stroke:#010202;strokeWidth:1.0879;stroke-miterlimit:1.5801;}\r\n\t\t.st4{fill:none;stroke:#FFFFFF;strokeWidth:1.0337;stroke-miterlimit:1.5801;}\r\n\t\t.st5{fill:none;stroke:#FFFFFF;strokeWidth:1.0879;stroke-miterlimit:1.5801;}\r\n\t\t.st6{fill:none;stroke:#010202;strokeWidth:0.9604;stroke-miterlimit:1.5801;}\r\n\t\t.st7{fill:none;stroke:#010202;strokeWidth:1.0459;stroke-miterlimit:1.5801;}\r\n\t\t.st8{fill:none;stroke:#010202;strokeWidth:0.9658;stroke-miterlimit:1.5801;}\r\n\t\t.st9{fill:#FFFFFF;stroke:#010202;strokeWidth:1.008;stroke-miterlimit:1.5801;}\r\n\t\t.st10{fill:none;stroke:#010202;strokeWidth:1.008;stroke-miterlimit:1.5801;}\r\n\t\t.st11{fill:none;stroke:#010202;strokeWidth:0.9387;stroke-miterlimit:1.5801;}\r\n\t\t.st12{fill:none;stroke:#010202;strokeWidth:0.9831;stroke-miterlimit:1.5801;}\r\n\t\t.st13{fill:none;stroke:#FFFFFF;strokeWidth:0.9604;stroke-miterlimit:1.5801;}\r\n\t\t.st14{fill:none;stroke:#FFFFFF;strokeWidth:1.0459;stroke-miterlimit:1.5801;}\r\n\t\t.st15{fill:none;stroke:#FFFFFF;strokeWidth:0.9658;stroke-miterlimit:1.5801;}\r\n\t\t.st16{fill:none;stroke:#FFFFFF;strokeWidth:1.008;stroke-miterlimit:1.5801;}\r\n\t\t.st17{fill:none;stroke:#FFFFFF;strokeWidth:0.9387;stroke-miterlimit:1.5801;}\r\n\t\t.st18{fill:none;stroke:#FFFFFF;strokeWidth:0.9831;stroke-miterlimit:1.5801;}\r\n\t\t.st19{fill:#010202;}\r\n\t\t.st20{opacity:0.129;}\r\n\t\t.st21{fill:none;stroke:#010202;strokeWidth:0.4807;stroke-miterlimit:1.5801;}\r\n\t\t.st22{fill:none;stroke:#010202;strokeWidth:0.5086;stroke-miterlimit:1.5801;}\r\n\t\t.st23{fill:none;stroke:#FFFFFF;strokeWidth:0.4807;stroke-miterlimit:1.5801;}\r\n\t\t.st24{fill:#FFFFFF;stroke:#FFFFFF;strokeWidth:0.5086;stroke-miterlimit:1.5801;}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    transform: "translate(-446.133 21.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    transform: "translate(1204.741 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    transform: "translate(0.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    className: "st0",
    d: "M-672.17,68.35c-17.41-0.33-34.82-0.23-52.21,0.12c0.01-12.52-0.25-25.03-0.42-37.38     c5.38-0.55,10.81-0.54,16.19,0.02c0.16-5.83,0.17-11.67-0.11-17.6c6.07,0.27,12.15,0.18,18.21-0.25     c0.38-3.86,0.4-7.75,0.04-11.61c5.96-0.48,11.95-0.5,17.97-0.49C-672.12,23.7-672.06,46.23-672.17,68.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    className: "st19",
    d: "M-724.6,68.71c-0.06-0.06-0.1-0.14-0.1-0.23c0.01-9.49-0.14-19.1-0.29-28.4     c-0.05-3-0.09-6-0.13-8.98c0-0.17,0.13-0.31,0.29-0.32c5.29-0.54,10.62-0.54,15.91-0.02c0.17-6.45,0.13-11.93-0.12-17.22     c-0.01-0.18,0.13-0.33,0.3-0.34c0,0,0,0,0,0c0.01,0,0.02,0,0.03,0c5.97,0.26,11.94,0.18,17.9-0.22     c0.36-3.75,0.37-7.53,0.02-11.28c-0.02-0.18,0.11-0.34,0.28-0.36c0,0,0,0,0,0h0.01c5.94-0.48,11.9-0.5,18-0.49     c0.18,0,0.32,0.14,0.32,0.32l0,0c0.34,20.55,0.45,42.53,0.32,67.19c0,0.09-0.03,0.17-0.1,0.23c-0.06,0.06-0.15,0.09-0.23,0.09     c-16.04-0.3-33.12-0.26-52.2,0.12h-0.01C-724.46,68.8-724.54,68.77-724.6,68.71z M-672.49,68.02c0.12-24.4,0.02-46.17-0.32-66.53     c-5.86-0.01-11.59,0.02-17.3,0.46c0.32,3.77,0.3,7.57-0.07,11.34c-0.01,0.16-0.14,0.28-0.3,0.3c-5.96,0.42-11.93,0.51-17.9,0.26     c0.24,5.3,0.27,10.79,0.09,17.27c0,0.09-0.04,0.18-0.11,0.24c-0.07,0.06-0.16,0.09-0.25,0.08c-5.26-0.55-10.56-0.56-15.83-0.04     c0.04,2.89,0.08,5.78,0.13,8.68c0.14,9.19,0.29,18.69,0.29,28.08c10.54-0.21,20.47-0.32,29.96-0.32     C-686.64,67.84-679.47,67.9-672.49,68.02L-672.49,68.02z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    transform: "translate(35.186 21.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    className: "st2",
    d: "M-722.18,9.51c2.19-0.01,4.72-0.1,6.91-0.11c0-2.11,0-4.39-0.03-6.59     c-2.32-0.11-4.64-0.11-6.95,0.01C-722.3,4.97-722.27,7.13-722.18,9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    className: "st19",
    d: "M-722.51,9.52c-0.09-2.47-0.12-4.6-0.07-6.71c0-0.17,0.13-0.31,0.31-0.32     c2.33-0.12,4.66-0.12,6.99-0.01c0.17,0.01,0.31,0.15,0.31,0.32c0.03,2.01,0.03,4.05,0.03,6.03V9.4c0,0.18-0.14,0.32-0.32,0.32     l0,0c-1.09,0.01-2.29,0.03-3.46,0.06c-1.16,0.02-2.36,0.05-3.45,0.06l0,0C-722.36,9.83-722.5,9.7-722.51,9.52z M-715.6,8.83     c0-1.87,0-3.81-0.03-5.72c-2.05-0.09-4.13-0.09-6.31,0.01c-0.03,1.91-0.01,3.85,0.07,6.06c1-0.01,2.08-0.03,3.13-0.05     c1.05-0.02,2.13-0.05,3.14-0.05L-715.6,8.83z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    transform: "translate(21.717 21.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    className: "st2",
    d: "M-723.16,9.51c2.19-0.01,4.72-0.1,6.91-0.11c0-2.11,0-4.39-0.03-6.59     c-2.32-0.11-4.64-0.11-6.95,0.01C-723.28,4.97-723.26,7.13-723.16,9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    className: "st19",
    d: "M-723.49,9.52c-0.09-2.47-0.12-4.61-0.07-6.71c0-0.17,0.13-0.31,0.31-0.32     c2.33-0.12,4.66-0.12,6.99-0.01c0.17,0.01,0.31,0.15,0.31,0.32c0.03,2.01,0.03,4.04,0.03,6.02V9.4c0,0.18-0.14,0.32-0.32,0.32     l0,0c-1.09,0.01-2.29,0.03-3.46,0.06c-1.16,0.02-2.36,0.05-3.45,0.06l0,0C-723.34,9.83-723.49,9.7-723.49,9.52z M-716.59,8.82     c0-1.87,0-3.8-0.03-5.7c-2.05-0.09-4.13-0.09-6.32,0.01c-0.03,1.91-0.01,3.85,0.07,6.06c1-0.01,2.08-0.03,3.13-0.05     c1.05-0.02,2.13-0.05,3.14-0.06V8.82z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    transform: "translate(35.365 34.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    className: "st2",
    d: "M-722.17,10.47c2.19-0.01,4.72-0.1,6.91-0.11c0-2.11,0-4.39-0.03-6.59     c-2.32-0.11-4.64-0.11-6.95,0.01C-722.28,5.93-722.26,8.09-722.17,10.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    className: "st19",
    d: "M-722.49,10.48c-0.09-2.47-0.12-4.61-0.07-6.71c0-0.17,0.13-0.31,0.31-0.32     c2.33-0.12,4.66-0.12,6.99-0.01c0.17,0.01,0.31,0.15,0.31,0.32c0.03,2.01,0.03,4.04,0.03,6.02v0.58c0,0.18-0.14,0.32-0.32,0.32     l0,0l0,0c-1.09,0.01-2.28,0.03-3.44,0.06c-1.16,0.02-2.37,0.05-3.47,0.06l0,0C-722.34,10.79-722.49,10.66-722.49,10.48z      M-715.58,9.77c0-1.87,0-3.8-0.03-5.7c-2.05-0.09-4.12-0.09-6.31,0.01c-0.03,1.91-0.01,3.85,0.07,6.06     c1-0.01,2.09-0.03,3.14-0.06c1.05-0.02,2.13-0.05,3.13-0.05L-715.58,9.77z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    transform: "translate(21.896 34.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    className: "st2",
    d: "M-723.15,10.47c2.19-0.01,4.72-0.1,6.91-0.11c0-2.11,0-4.39-0.03-6.59     c-2.32-0.11-4.64-0.11-6.95,0.01C-723.27,5.93-723.24,8.09-723.15,10.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    className: "st19",
    d: "M-723.48,10.48c-0.09-2.47-0.12-4.6-0.07-6.71c0-0.17,0.14-0.31,0.31-0.32     c2.33-0.12,4.66-0.12,6.99-0.01c0.17,0.01,0.31,0.15,0.31,0.32c0.03,2.01,0.03,4.04,0.03,6.02v0.58c0,0.18-0.14,0.32-0.32,0.32     l0,0c-1.09,0.01-2.29,0.03-3.44,0.06c-1.16,0.02-2.37,0.05-3.47,0.06l0,0C-723.33,10.79-723.47,10.66-723.48,10.48z      M-716.57,9.78c0-1.87,0-3.8-0.03-5.7c-2.05-0.09-4.12-0.09-6.32,0.01c-0.03,1.91-0.01,3.85,0.07,6.06     c1.01-0.01,2.09-0.03,3.14-0.05c1.05-0.02,2.13-0.05,3.13-0.05L-716.57,9.78z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    transform: "translate(35.365 47.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    className: "st2",
    d: "M-722.17,11.43c2.19-0.01,4.72-0.1,6.91-0.11c0-2.11,0-4.39-0.03-6.59     c-2.32-0.11-4.64-0.11-6.95,0.01C-722.28,6.89-722.26,9.05-722.17,11.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    className: "st19",
    d: "M-722.49,11.44c-0.09-2.47-0.12-4.61-0.07-6.72c0-0.17,0.14-0.31,0.31-0.32     c2.33-0.12,4.66-0.12,6.99-0.01c0.17,0.01,0.31,0.15,0.31,0.32c0.03,2.01,0.03,4.04,0.03,6.01v0.58c0,0.18-0.14,0.32-0.32,0.32     l0,0c-1.09,0.01-2.29,0.03-3.45,0.06c-1.16,0.02-2.36,0.05-3.46,0.06l0,0C-722.34,11.75-722.49,11.62-722.49,11.44z      M-715.58,10.74c0-1.87,0-3.8-0.03-5.7c-2.05-0.09-4.12-0.09-6.31,0.01c-0.03,1.91-0.01,3.85,0.07,6.06     c1-0.01,2.08-0.03,3.13-0.05c1.05-0.02,2.13-0.05,3.14-0.05L-715.58,10.74z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    transform: "translate(21.896 47.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    className: "st2",
    d: "M-723.15,11.43c2.19-0.01,4.72-0.1,6.91-0.11c0-2.11,0-4.39-0.03-6.59     c-2.32-0.11-4.64-0.11-6.95,0.01C-723.27,6.89-723.24,9.05-723.15,11.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    className: "st19",
    d: "M-723.48,11.44c-0.09-2.47-0.12-4.61-0.07-6.72c0-0.17,0.14-0.31,0.31-0.32     c2.33-0.12,4.66-0.12,6.99-0.01c0.17,0.01,0.31,0.15,0.31,0.32c0.03,2.01,0.03,4.04,0.03,6.02v0.58c0,0.18-0.14,0.32-0.32,0.32     l0,0c-1.09,0.01-2.29,0.03-3.45,0.06c-1.16,0.03-2.36,0.05-3.46,0.06l0,0C-723.33,11.76-723.47,11.62-723.48,11.44z      M-716.57,10.74c0-1.87,0-3.8-0.03-5.7c-2.05-0.09-4.13-0.09-6.32,0.01c-0.03,1.91-0.01,3.85,0.07,6.06     c1-0.01,2.09-0.03,3.14-0.05c1.05-0.02,2.13-0.05,3.14-0.05C-716.57,10.99-716.57,10.74-716.57,10.74z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    transform: "translate(35.667 23.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    className: "st19",
    d: "M-722.47,2.85L-722.47,2.85l6.55-0.06c0.06,0,0.11-0.05,0.11-0.11     c0-0.06-0.05-0.11-0.11-0.11l0,0l-6.55,0.06c-0.06,0.01-0.1,0.06-0.1,0.12c0,0,0,0,0,0C-722.56,2.8-722.52,2.84-722.47,2.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    transform: "translate(21.994 23.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    className: "st19",
    d: "M-723.47,2.86L-723.47,2.86c1.58-0.09,3.46-0.07,5.29-0.07c0.56,0,1.12,0,1.65,0     c0.06,0.01,0.11-0.03,0.12-0.09c0.01-0.06-0.03-0.11-0.09-0.12c-0.01,0-0.02,0-0.03,0c-0.54,0-1.09,0-1.65,0     c-1.82-0.01-3.72-0.02-5.3,0.07c-0.06,0-0.11,0.05-0.1,0.11C-723.57,2.81-723.52,2.86-723.47,2.86L-723.47,2.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    transform: "translate(35.851 36.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    className: "st19",
    d: "M-722.45,3.76L-722.45,3.76c0.95-0.03,2.07-0.02,3.17-0.01c1.12,0.01,2.28,0.02,3.28-0.01     c0.06,0,0.11-0.05,0.11-0.11s-0.05-0.11-0.11-0.11c-1,0.04-2.15,0.03-3.27,0.01c-1.1-0.01-2.23-0.02-3.18,0.01     c-0.06,0-0.11,0.05-0.11,0.11C-722.56,3.71-722.51,3.76-722.45,3.76L-722.45,3.76z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    transform: "translate(22.245 36.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    className: "st19",
    d: "M-723.44,3.8L-723.44,3.8c1.56-0.06,3.99-0.09,6.67-0.07l0,0c0.06,0,0.11-0.05,0.11-0.11     c0-0.06-0.05-0.11-0.11-0.11c-1.27-0.01-4.45-0.02-6.68,0.07c-0.06,0-0.11,0.05-0.11,0.11c0,0.06,0.05,0.11,0.11,0.11H-723.44z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    transform: "translate(35.882 49.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    className: "st19",
    d: "M-719.49,4.73c1.24,0,2.49-0.01,3.67-0.05c0.06,0,0.11-0.05,0.11-0.11     c0-0.06-0.05-0.11-0.11-0.11c-1.65,0.06-3.42,0.05-5.14,0.05h-1.47c-0.06-0.01-0.11,0.03-0.12,0.09     c-0.01,0.06,0.03,0.11,0.09,0.12l0,0c0.01,0,0.02,0,0.03,0h1.46C-720.47,4.73-719.98,4.73-719.49,4.73z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    transform: "translate(22.245 49.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    className: "st19",
    d: "M-716.74,4.72c0.06,0,0.11-0.05,0.11-0.11c0-0.06-0.05-0.11-0.11-0.11     c-2.23-0.05-4.49-0.06-6.71-0.04c-0.06,0-0.11,0.05-0.11,0.11c0,0.06,0.05,0.11,0.11,0.11l0,0     C-721.23,4.66-718.97,4.68-716.74,4.72L-716.74,4.72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    transform: "translate(8.377 34.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    className: "st2",
    d: "M-724.14,10.47c2.19-0.01,4.72-0.1,6.91-0.11c0-2.11,0-4.39-0.03-6.59     c-2.32-0.11-4.64-0.11-6.95,0.01C-724.26,5.93-724.23,8.09-724.14,10.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    className: "st19",
    d: "M-724.46,10.48c-0.09-2.47-0.12-4.6-0.07-6.71c0-0.17,0.13-0.31,0.31-0.32     c2.33-0.12,4.66-0.12,6.99-0.01c0.17,0.01,0.31,0.15,0.31,0.32c0.03,2.01,0.03,4.05,0.03,6.03v0.57c0,0.18-0.14,0.32-0.32,0.32     l0,0c-1.09,0.01-2.29,0.03-3.44,0.06c-1.16,0.02-2.37,0.05-3.47,0.06l0,0C-724.31,10.79-724.46,10.66-724.46,10.48z      M-717.55,9.79c0-1.87,0-3.81-0.03-5.71c-2.05-0.09-4.12-0.09-6.32,0.01c-0.03,1.91-0.01,3.85,0.07,6.06     c1.01-0.01,2.09-0.03,3.14-0.05c1.05-0.02,2.13-0.05,3.13-0.05V9.79z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    transform: "translate(8.377 47.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    className: "st2",
    d: "M-724.14,11.43c2.19-0.01,4.72-0.1,6.91-0.11c0-2.11,0-4.39-0.03-6.59     c-2.32-0.11-4.64-0.11-6.95,0.01C-724.26,6.89-724.23,9.05-724.14,11.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    className: "st19",
    d: "M-724.46,11.44c-0.09-2.47-0.12-4.61-0.07-6.72c0-0.17,0.14-0.31,0.31-0.32     c2.33-0.12,4.66-0.12,6.99-0.01c0.17,0.01,0.31,0.15,0.31,0.32c0.03,2.01,0.03,4.05,0.03,6.03v0.57c0,0.18-0.14,0.32-0.32,0.32     l0,0c-1.09,0.01-2.29,0.03-3.45,0.06c-1.16,0.02-2.36,0.05-3.46,0.06l0,0C-724.31,11.76-724.46,11.62-724.46,11.44z      M-717.55,10.75c0-1.87,0-3.81-0.03-5.71c-2.05-0.09-4.12-0.09-6.32,0.01c-0.03,1.91-0.01,3.85,0.07,6.06     c1-0.01,2.09-0.03,3.14-0.05c1.05-0.02,2.13-0.05,3.14-0.05V10.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    transform: "translate(8.726 36.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    className: "st19",
    d: "M-724.43,3.8L-724.43,3.8c1.56-0.06,3.99-0.09,6.67-0.07l0,0c0.06,0,0.11-0.05,0.11-0.11     c0-0.06-0.05-0.11-0.11-0.11c-1.27-0.01-4.45-0.02-6.68,0.07c-0.06,0.01-0.1,0.06-0.09,0.12c0,0,0,0,0,0     C-724.53,3.75-724.49,3.79-724.43,3.8L-724.43,3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    transform: "translate(8.716 49.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    className: "st19",
    d: "M-717.72,4.72c0.06,0,0.11-0.05,0.11-0.11c0-0.06-0.05-0.11-0.11-0.11     c-2.23-0.05-4.49-0.06-6.71-0.04c-0.06,0-0.11,0.05-0.11,0.11l0,0c0,0.06,0.04,0.1,0.1,0.11h0.01     C-722.2,4.66-719.95,4.68-717.72,4.72L-717.72,4.72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    transform: "translate(0 59.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    className: "st0",
    d: "M-669.98,9.66c-18.7,0-36.36-0.14-54.39,0c-0.48,0-0.48-4.05-0.48-4.05     c5.89,0.44,39.47-0.49,54.96,0.19C-669.78,7.08-669.81,8.38-669.98,9.66z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    className: "st19",
    d: "M-688.79,9.94c-12.18-0.03-23.68-0.06-35.58,0.03c-0.3,0-0.8,0-0.8-4.37     c0-0.18,0.14-0.32,0.32-0.32c0.01,0,0.02,0,0.03,0c2.56,0.19,10.52,0.12,19.73,0.04c11.8-0.11,26.48-0.23,35.21,0.15     c0.16,0.01,0.3,0.14,0.31,0.3c0.12,1.31,0.09,2.63-0.09,3.93c-0.02,0.16-0.16,0.28-0.32,0.28     C-676.35,9.98-682.68,9.96-688.79,9.94z M-705.08,5.97c-8.85,0.08-16.53,0.14-19.43-0.02c-0.03,1.13,0.07,2.26,0.28,3.38     c11.84-0.09,23.31-0.06,35.45-0.03c6.03,0.02,12.25,0.03,18.53,0.03c0.12-1.07,0.15-2.15,0.07-3.23     C-678.94,5.73-693.42,5.86-705.08,5.97L-705.08,5.97z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    transform: "translate(47.388 2.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    className: "st19",
    d: "M-721.36,6.97L-721.36,6.97c0.06,0,0.11-0.05,0.11-0.11l-0.24-5.75     c0-0.06-0.05-0.11-0.11-0.11c-0.06,0-0.11,0.05-0.11,0.11l0,0l0.24,5.75C-721.46,6.92-721.42,6.96-721.36,6.97z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    transform: "translate(45.733 2.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    className: "st19",
    d: "M-721.72,3.95c0.06,0,0.11-0.05,0.11-0.11l0.13-2.72c0-0.06-0.05-0.11-0.11-0.11     c-0.06,0-0.1,0.04-0.11,0.09v0.01l-0.13,2.72C-721.84,3.89-721.79,3.95-721.72,3.95C-721.73,3.95-721.73,3.95-721.72,3.95     L-721.72,3.95z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    transform: "translate(44.152 2.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    className: "st19",
    d: "M-721.84,3.14c0.06,0,0.1-0.04,0.11-0.1l0.13-1.89c0.01-0.06-0.03-0.11-0.09-0.12l0,0     c-0.06-0.01-0.11,0.03-0.12,0.09v0c0,0.01,0,0.01,0,0.02l-0.13,1.89C-721.95,3.08-721.91,3.13-721.84,3.14     C-721.85,3.14-721.85,3.14-721.84,3.14L-721.84,3.14L-721.84,3.14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    transform: "translate(17.766 13.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    className: "st19",
    d: "M-723.64,6.05L-723.64,6.05c0.06,0,0.11-0.05,0.11-0.11l0,0l-0.12-4.02     c0-0.06-0.05-0.11-0.11-0.11c-0.06,0-0.11,0.05-0.11,0.11l0,0l0.12,4.02C-723.75,6-723.7,6.05-723.64,6.05L-723.64,6.05z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    transform: "translate(19.189 13.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    className: "st19",
    d: "M-723.65,4.06L-723.65,4.06c0.06,0,0.11-0.05,0.11-0.11l-0.01-2.03     c0-0.06-0.05-0.11-0.11-0.11l0,0c-0.06,0-0.11,0.05-0.11,0.11l0,0l0.01,2.03C-723.76,4.01-723.71,4.06-723.65,4.06     C-723.65,4.06-723.65,4.06-723.65,4.06z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    transform: "translate(20.818 13.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    className: "st19",
    d: "M-723.52,3.39c0.06,0,0.1-0.04,0.11-0.1c0.04-0.46,0.04-0.92-0.02-1.38     c-0.01-0.06-0.06-0.1-0.12-0.09h0c-0.06,0.01-0.1,0.06-0.09,0.12v0c0.06,0.44,0.06,0.89,0.02,1.33     c-0.01,0.06,0.03,0.11,0.09,0.12l0,0L-723.52,3.39L-723.52,3.39z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    transform: "translate(2.358 29.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    className: "st19",
    d: "M-724.68,8.06L-724.68,8.06c0.06,0,0.11-0.05,0.11-0.11l0,0c-0.03-1.61-0.1-3.24-0.21-4.85     c0-0.06-0.05-0.1-0.11-0.1l0,0c-0.06,0-0.1,0.06-0.1,0.11l0,0c0.11,1.6,0.18,3.23,0.21,4.84     C-724.78,8.02-724.73,8.06-724.68,8.06L-724.68,8.06z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    transform: "translate(3.699 29.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    className: "st19",
    d: "M-724.68,5.36L-724.68,5.36c0.06,0,0.11-0.05,0.11-0.11c0,0,0,0,0-0.01l-0.11-2.14     c0-0.06-0.05-0.11-0.11-0.11c0,0,0,0-0.01,0c-0.06,0-0.11,0.05-0.11,0.11l0,0l0.11,2.14C-724.79,5.3-724.75,5.35-724.68,5.36     C-724.69,5.36-724.68,5.36-724.68,5.36z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    className: "st0",
    d: "M476.21,17.21c-3.59,0-5.88,1.81-6.32,4.43c-0.37,2.58,1.06,5.08,3.47,6.08   c4.11,1.76,8.8-0.95,8.8-4.81C482.15,18.99,479.24,17.21,476.21,17.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    className: "st21",
    d: "M476.03,28.24c-0.9,0-1.79-0.18-2.62-0.54c-2.39-1-3.8-3.48-3.42-6.04   c0.47-2.73,2.84-4.42,6.2-4.42c2.91,0,5.86,1.75,5.86,5.66c-0.03,1.75-0.95,3.36-2.44,4.27C478.54,27.87,477.3,28.24,476.03,28.24z   "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    className: "st0",
    d: "M466.08,48.64c0.3-3.49,0-7.07,0.7-10.47c0.86-4.16,3.34-7.85,6.61-9.28   c3.45-1.45,7.45-0.25,9.54,2.86c1.9,2.68,2.49,6.4,2.73,9.95c0.15,2.31,0.19,4.62,0.23,6.94L466.08,48.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    className: "st22",
    d: "M485.36,48.68H466.6c-0.32,0-0.57-0.26-0.57-0.57c0,0,0,0,0,0c0-0.02,0-0.03,0-0.05   c0.11-1.22,0.13-2.49,0.16-3.72c-0.02-2.1,0.15-4.2,0.51-6.27c0.88-4.28,3.41-7.81,6.6-9.2c3.52-1.49,7.6-0.28,9.74,2.9   c1.99,2.82,2.49,6.68,2.69,9.73c0.15,2.2,0.18,4.44,0.21,6.6C485.93,48.41,485.68,48.67,485.36,48.68L485.36,48.68z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    transform: "translate(1194.772 36.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    className: "st19",
    d: "M-725.62,10.61c-0.11,0-0.19-0.08-0.2-0.19c-0.12-1.74-0.09-3.48,0.08-5.21    c0.01-0.11,0.12-0.19,0.23-0.17c0.11,0.01,0.18,0.11,0.18,0.21c-0.17,1.71-0.2,3.43-0.08,5.14c0.01,0.11-0.08,0.21-0.19,0.21l0,0    L-725.62,10.61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    transform: "translate(1197.259 39.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    className: "st19",
    d: "M-725.45,7.82c-0.11,0-0.2-0.09-0.2-0.2l-0.06-2.19c0-0.11,0.08-0.2,0.19-0.21l0,0l0,0    c0.11,0,0.2,0.09,0.21,0.2l0.06,2.19C-725.25,7.73-725.34,7.82-725.45,7.82L-725.45,7.82L-725.45,7.82L-725.45,7.82z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinnn04);
export default __webpack_public_path__ + "static/media/drinnn-04.2de5ed6c1b4aac6432a8529c3554e6bf.svg";
export { ForwardRef as ReactComponent };